import axios from "axios";

const state = {
    user: {},
    profile: {},
	profileLists: [],
	nonMemberLists: [],
};

const actions = {
    async loadUser(context){
        return axios.get("/api/1/user/info").then(function(response){
            context.commit("setUser", response.data)
        });
    },    
    async loadProfile(context, uid){
        return axios.get("/api/1/users", {params:{u: uid}}).then(function(response){
            context.commit("setProfile", response.data.result[0])
        });
    },

	async loadProfilePublic(context, uid){
        return axios.get("/api/1/users/public", {params:{u: uid}}).then(function(response){
            context.commit("setProfile", response.data.result[0])
        });
    },

	async profileListsLoad(context,uid=null){
		var query = context.state.profile.profileListsQuery;
        return axios.get("/api/1/profile/lists",{params:{query:query,uid:uid}}).then(function(response){

            if(response.data.success){
                context.commit('profileListsSet', response.data.result);
            }
        })
    },

	async profileLoadNonMemberLists (context,uid){

        var obj = {
            params:{
                uid: uid
            }
        }

        return axios.get("/api/1/nonmemberLists",obj).then(function(response){
            context.commit('profileSetNonMemberLists',response.data.result);
        });

    },


	async profileAddLists(context,data) {

        var lists = data.lists;
        var user = data.user;

        var all = false;

        for(var i=0; i<lists.length; i++){
            if(lists[i].tnam == "All Lists"){
                all = true;
                break;
            }
        }

        if(all){
            //All Lists was selected so we create a membership with each list 
            lists = state.nonMemberLists;
        }

        var promises = [];
        for(var i=0; i<lists.length; i++){
            promises.push(
                axios.put("/api/1/teams/" + lists[i].tid + "/members/" + user)
            );
        }

        return Promise.all(promises);

    },

	updateUserSort(context,sort){
		context.commit("setUserSort",sort);
	},

	updateUserAppPath(context, path){
		context.commit("setUserPath",path);
	},

	async userListsUpdate(context,event){
		var user_id = event.user_id;

		if(context.rootState.user.user.uid==user_id){
			actions.loadUser(context);
		}

	}
}

const mutations = {
	setUser(state,data){
		state.user=data;
	},
	setUserSort(state,sort){
		state.user.current_sort = sort;
	},
	setUserPath(state,path){
		state.user.current_app_path = path;
	},
    setProfile(state,data){
		state.profile=data;
	},
	profileListsSet(state,data){
        state.profileLists = data;
    },

	profileSetNonMemberLists(state,data){
        state.nonMemberLists = data;
        if(state.nonMemberLists.length>0){
            state.nonMemberLists.unshift({tnam:"All Lists"});
        }
        
    }

}

const getters = {
	user(state){
		return state.user
	},
    profile(state){
		return state.profile
	},
	profileLists(state){
        return state.profileLists;
    },

	nonMemberLists(state){
        return state.nonMemberLists;
    },

	listApp(state){
		var result = "list";

		if(state.user.current_app=='board'){
			result = "list-kanban";
		}else if(state.user.current_app=='card'){
			result = "list-open";
		}

		return result;
	},

};
  

export default {
    state,
    actions,
    mutations,
    getters
};